var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.95 0.652344L13.1203 11.9323L25.2906 0.652344H0.95ZM0 1.53223V17.0219L8.03029 8.97166L0 1.53223ZM26.24 1.53223L18.2103 8.97223L26.24 17.0225V1.53223ZM8.96 9.84251L0.9 17.9322H25.34L17.28 9.84251L13.5599 13.2825C13.313 13.5162 12.9269 13.5162 12.68 13.2825L8.96 9.84251Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f8a6f7775aa2c9d50ae0a20dc731b7f4.svg";
export { ForwardRef as ReactComponent };